export const getGroupedOptions = (defaultRoles, customRoles) => {
     return [
        {
            label: 'Default Roles',
            options: defaultRoles
        },
        {
            label: 'Custom Roles',
            options: customRoles.map((role) => ({ value: role.rolename, label: role.rolename })) || []
        }
        
    ];
}